import EditorFeatureTitle from "../../components/editor/EditorFeatureTitle";
import EditorFeatureSubtitle from "../../components/editor/EditorFeatureSubtitle";

const GrammarReport = () => {
	return (
		<div className="bg-white shadow-sm lg:p-9 xl:p-9 2xl:p-10 flex-1 flex flex-col overflow-hidden">
			<EditorFeatureTitle title="Grammer Report" className='flex-none' />
			<EditorFeatureSubtitle className='flex-none'>
				<div className="flex items-center whitespace-nowrap">
					We have found
					<div className="flex-none xl:h-7 2xl:h-8 xl:w-7 2xl:w-8 mx-2 rounded-full bg-ffa grid place-items-center text-white text-xs 2xl:text-sm">
						<span className="inline-block mt-px">11</span>
					</div>
					improvements in your document.
				</div>
			</EditorFeatureSubtitle>
			<div className='flex-1 scrollbar-y-2 pr-5 -mr-5 mt-9'>
				<div className="px-6 relative pt-4 pb-7 bg-f0 rounded-10">
					<div>
						<span className='text-xl font-bold text-ef'>Misspelling</span>
						<span className='text-lg font-normal text-7d ml-4'>Change the following spellings</span>
					</div>
					<div className='mt-4 line-through text-2xl font-bold text-7d'>Micha</div>
					<div className='mt-4 text-lg font-normal text-7d'>Possible Matches</div>
					<div className='mt-3 space-x-2.5'>
						<button className='text-xl font-bold py-3 px-4 text-white bg-7d rounded'>Mica</button>
						<button className='text-xl font-bold py-3 px-4 text-white bg-7d rounded'>Micah</button>
						<button className='text-xl font-bold py-3 px-4 text-white bg-7d rounded'>Mich</button>
						<button className='text-xl font-bold py-3 px-4 text-white bg-7d rounded'>Mocca</button>
					</div>
					<i className="mdi mdi-dots-horizontal absolute right-4 top-1 text-3xl text-db"></i>
				</div>
				<div className="lg:space-y-4 2xl:space-y-5 lg:mt-7 xl:mt-8 2xl:mt-9">
					<div className="flex relative lg:py-4 2xl:py-5 lg:px-5 2xl:px-6 rounded-lg border border-db items-center">
						<div className="text-xl font-bold text-ffa">Typographical</div>
						<div className="text-lg text-7d ml-4">Use smart opening</div>
						<i className="mdi mdi-dots-vertical absolute right-6 top-1/2 transform -translate-y-1/2 text-3xl text-db"></i>
					</div>
					<div className="flex relative lg:py-4 2xl:py-5 lg:px-5 2xl:px-6 rounded-lg border border-db items-center">
						<div className="text-xl font-bold text-ffa">Typographical</div>
						<div className="text-lg text-7d ml-4">Use smart opening</div>
						<i className="mdi mdi-dots-vertical absolute right-6 top-1/2 transform -translate-y-1/2 text-3xl text-db"></i>
					</div>
					<div className="flex relative lg:py-4 2xl:py-5 lg:px-5 2xl:px-6 rounded-lg border border-db items-center">
						<div className="text-xl font-bold text-ffa">Misspelling</div>
						<div className="text-lg text-7d ml-4">Change Spellings</div>
						<i className="mdi mdi-dots-vertical absolute right-6 top-1/2 transform -translate-y-1/2 text-3xl text-db"></i>
					</div>
					<div className="flex relative lg:py-4 2xl:py-5 lg:px-5 2xl:px-6 rounded-lg border border-db items-center">
						<div className="text-xl font-bold text-ffa">White Space</div>
						<div className="text-lg text-7d ml-4">Lorem ipsum dolor sit </div>
						<i className="mdi mdi-dots-vertical absolute right-6 top-1/2 transform -translate-y-1/2 text-3xl text-db"></i>
					</div>
					<div className="flex relative lg:py-4 2xl:py-5 lg:px-5 2xl:px-6 rounded-lg border border-db items-center">
						<div className="text-xl font-bold text-ffa">Grammar</div>
						<div className="text-lg text-7d ml-4">Lorem ipsum dolor sit </div>
						<i className="mdi mdi-dots-vertical absolute right-6 top-1/2 transform -translate-y-1/2 text-3xl text-db"></i>
					</div>
				</div>
			</div>
		</div>
	);
};

export default GrammarReport;
